import React from 'react';
import { RichTextInput } from "./RichTextInput";
import { RichTextProps } from './interface';

export function RichText(props: RichTextProps) {
  return <RichTextInput value={props.content ?? null} readOnly />;
}